import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Collapse from "react-bootstrap/Collapse";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { toast } from 'react-toastify';

import '../Profile.css'

import { toggleBoxColumn } from '../../../utils/UIUtils.js'
import { checkClustererIdentifier } from "../../../utils/ClustererAPI.js";
import { renderDatasetGroups, getDatasetGroups } from '../../../utils/ParametersUtils';

export class ClustererModal extends Component {
  constructor(props) {
    super(props);

    var selectedClustererType

    if (props.clusterer) {
      if (props.clusterer.clusterer) {
        // for (var i in props.dataClusterers) {
        //   if (props.dataClusterers[i].identifier === props.clusterer.clusterer) {
        //     selectedClustererType = props.dataClusterers[i];
        //     break;
        //   }
        // }
      } else if (props.clusterer.clustererPrototypeId) {
        for (var i in props.userClusterers) {
          if (props.userClusterers[i].id === props.clusterer.clustererPrototypeId) {
            selectedClustererType = props.userClusterers[i];
            break;
          }
        }
      }

    }

    this.state = {
      clusterer: props.clusterer,
      selectedClustererType,
      // savedAnnotators: [],
      // loadedAnnotators: false,
      // showSaveAsForm: false,
      // saveAsName: '',

      identifierExists: false,

      parametersOpen: true,
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }


  componentDidMount() {
    if (this.props.clusterer) {
      this.completeFields(this.props.clusterer)
    }
  }

  // Fill all fields except for preprocess. Works for editing and saved annotators
   completeFields(response) {

    // let clusterer = {
    //   clusterer: response.clusterer,
    // }

    var selectedClustererType;
    if (response.clusterer) {
      // this.clustererType.value = 's' + response.clusterer;
      // selectedClustererType = this.props.dataClusterers.filter(el => el.identifier === this.clustererType.value.substring(1))[0]
    } else {
      this.clustererType.value = 'u' + response.clustererPrototypeId;
      selectedClustererType = this.props.userClusterers.filter(el => el.id === this.clustererType.value.substring(1))[0]
    }



    this.postCompleteFields(response, selectedClustererType)
  }

  postCompleteFields(clusterer, selectedClustererType) {
    this.setState({ clusterer, selectedClustererType, selectedParameters: clusterer.parameters
      // , valuesLists: (selectedClustererType.fields ? { names: selectedClustererType.fields.map(e => e.name)} : undefined)
    },
     () => {
       if (clusterer.parameters) {
        clusterer.parameters.map(el => {
          this['param-' + el.name].value = el.value
        })
      }
    }  )
  }
  // // Fiil preprocess fields
  // get saveAsCssClasses() {
  //   return this.state.showSaveAsForm ? 'showForm mt-2 mb-2' : 'hideForm mt-2 mb-2';
  // }

  handleSubmit(event) {
    event.preventDefault();

    var params = [];
    for (const i in this.state.selectedClustererType.parameters) {
      params.push({ name: this.state.selectedClustererType.parameters[i].name, value: this['param-' + this.state.selectedClustererType.parameters[i].name].value })
    }

    var _this = this;

    var tags = [];
    tags = this.annotatorTags.value.split(",");
    for (var i in tags) {
      tags[i] = tags[i].trim();
    }

    if (this.formIsValid()) {

        this.props.onOK(this.props.clusterer ? this.props.clusterer.id : null,
                        this.name.value,
                        this.identifier.value,
                        this.state.selectedClustererType.identifier, // system clusterer
                        this.state.selectedClustererType.id, // user clusterer
                        tags,
                        getDatasetGroups(this.props.dataset, this),
                        params);
    }
  }

  existsClustererIdentifier() {
    if (this.identifier.value) {
      checkClustererIdentifier(this.identifier.value, this.props.dataset.id)
      .then(response => {
        if (!response.data.valid || response.data.exists) {
           this.setState( {identifierExists : true })
        } else
            this.setState( {identifierExists : false })
        })
      }
   }

   formIsValid() {
     var ok = !(this.identifier && this.identifier.value && ((!this.props.dataset && this.state.identifierExists) || (this.props.dataset && this.state.identifierExists && this.props.dataset.identifier !== this.identifier.value)));

     return ok;
   }

  // getTags() {
  //   var tags = null
  //   if (this.tags) {
  //     tags = [];
  //     for (var t of this.tags.value.split(",")) {
  //       if (t.trim().length > 0) {
  //         tags.push(t.trim())
  //       }
  //     }
  //
  //     if (tags.length == 0) {
  //       tags = null;
  //     }
  //   }
  //
  //   return tags
  // }

  clustererTypeChanged() {

    if (this.clustererType.value.startsWith('s')) {
      // var selectedClustererType = this.props.dataClusterers.filter(el => el.identifier === this.clustererType.value.substring(1))[0]
    } else {
      var selectedClustererType = this.props.userClusterers.filter(el => el.id === this.clustererType.value.substring(1))[0]
    }

    this.setState({ selectedClustererType: selectedClustererType
      // , valuesLists: (selectedClustererType.fields ? { names: selectedClustererType.fields.map(e => e.name)} : undefined)
    })


  }


  jsonldsort(a, b) {
    if (a['@value'] !== undefined && b['@value'] !== undefined) {
      if (a['@value'] < b['@value']) {
        return -1;
      } else if (a['@value'] > b['@value']) {
        return 1;
      } else {
        return 0;
      }
    } else if (a['@id'] !== undefined && b['@id'] !== undefined) {
      if (a['@id'] < b['@id']) {
        return -1;
      } else if (a['@id'] > b['@id']) {
        return 1;
      } else {
        return 0;
      }
    }
  }


  throwToast(type, message) {
    if (type === 'error') {
      toast.error(message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    else if (type === 'success') {
      toast.success(message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  getDefaultParameter(name) {
    if (!this.state.selectedParameters) {
      return null
    }
    var obj = this.state.selectedParameters.find(p => p.name === name);
    if (obj == null) {
      return null;
    } else {
      return obj.value;
    }

  }



// In your React component:

  render() {

    return (
      <Modal show={this.props.show} onHide={this.props.onClose} animation={false} backdrop="static" size="xl" >
        <Form onSubmit={this.handleSubmit} id="annotator-modal-form">
          <Modal.Header>
            <Modal.Title>{this.props.clusterer && this.props.clusterer.id ? 'Edit Clusterer' : 'New Clusterer'}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
          <Form.Group>
            <Form.Label className="required">Name</Form.Label>
            <Form.Control ref={node => (this.name = node)}
                 onChange={() => this.setState({ error: false })}
                 pattern="\S.*"
                 defaultValue={this.state.clusterer ? this.state.clusterer.name : ""}
                 required/>
          </Form.Group>

          <Form.Group>
            <Form.Label>Identifier</Form.Label>
            <Form.Control ref={node => (this.identifier = node)}
                 onChange={() => this.existsClustererIdentifier()}
                 isInvalid={this.identifier && this.identifier.value && ((!this.props.clusterer && this.state.identifierExists) || (this.props.clusterer && this.state.identifierExists && this.props.clusterer.identifier !== this.identifier.value))}
                 defaultValue={this.props.clusterer ? this.props.clusterer.identifier : ""}/>
            <Form.Control.Feedback type="invalid">
                 Identifier already exists or is invalid.
           </Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Form.Label className="required">Clusterer</Form.Label>
            <Form.Control as="select" ref={node => (this.clustererType = node)}
              defaultValue={this.state.clusterer ? (this.state.clusterer.identifier ? 's' + this.state.clusterer.clusterer : 'u' + this.state.clusterer.clustererPrototypeId) : ''}
              onChange={() => this.clustererTypeChanged()}
              required>
              <option hidden disabled value=''> -- Select a clusterer -- </option>
              {/*this.props.mode == 'LEGACY' && this.props.dataClusterers.map((el, index) =>
                <option key={index} value={'s' + el.identifier}>{el.title}</option>
              )*/}
              {this.props.userClusterers && this.props.userClusterers.map((el, index) =>
                <option key={index} value={'u' + el.id}>{el.name}</option>
              )}
            </Form.Control>
          </Form.Group>

          <Form.Group>
            <Form.Label className="required">Annotator tags</Form.Label>
            <Form.Control ref={node => (this.annotatorTags = node)}
                 onChange={() => this.setState({ error: false })}
                 defaultValue={(this.state.clusterer && this.state.clusterer.annotatorTags) ? this.state.clusterer.annotatorTags.join(', ') : ""}
                 required/>
          </Form.Group>

          {this.state.selectedClustererType && this.state.selectedClustererType.parameters &&
            <Container className={this.state.selectedClustererType.parameters.length > 0 ? "groupborder" : "groupborder-empty"}>
              <Row className={this.state.selectedClustererType.parameters.length > 0 ? "header" : "header-empty"}>

                <Col className="bold">
                  <span className="crimson-std">Parameters</span>
                </Col>

                {toggleBoxColumn('parametersOpen', this, null, null, this.state.selectedClustererType.parameters)}

                <Col className="mybutton" md={1}>
                </Col>
              </Row>

              <Collapse in={this.state.parametersOpen}>
                <div>

                {this.state.selectedClustererType.parameters.map((el, index) =>
                  <Form.Group key={index}>
                    <Form.Label className={"" + (el.required? " required":"")}>[{this.state.selectedClustererType.title ? this.state.selectedClustererType.title : this.state.selectedClustererType.name }] : {el.name}</Form.Label>
                    {(!el.values || el.values.length === 0) && (el.type && el.type.startsWith("text") ?
                      <Form.Control required={el.required} as="textarea" ref={node => (this['param-' + el.name] = node)} /> :
                      <Form.Control required={el.required} ref={node => (this['param-' + el.name] = node)} />)
                    }
                    {el.values && el.values.length > 0 &&
                      <Form.Control as="select" ref={node => (this['param-' + el.name] = node)}
                        onChange={() => this.parameterChanged()}
                        defaultValue={el.defaultValue}
                        required={el.required}
                        >
                        {el.values.map((v, index) => {
                            return <option key={index} value={v}>{v}</option>
                         })
                      }
                      </Form.Control>}

                  </Form.Group>)}
                </div>
              </Collapse>
            </Container>}

            {renderDatasetGroups(this.props.dataset, this.state.clusterer, this)}

          </Modal.Body>
          <Modal.Footer className="justify-content-between">
              <React.Fragment>
                  <Button type="submit" variant="primary" id="submit-btn" className="mr-2">
                    {this.props.clusterer && this.props.clusterer.id ? 'Update' : 'Create'}
                  </Button>
                  <Button variant="secondary" onClick={this.props.onClose}>
                    Cancel
                  </Button>
              </React.Fragment>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}

export default ClustererModal;
